export default __webpack_public_path__ + "static/media/park-icon.4fe9d770.png";